import React from 'react';
import BrowseListingsPage from '../browse-listings/BrowseListingsPage';

const HomePage: React.FC = () => {
  return <BrowseListingsPage />;
};

export default HomePage;
